"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _eventing = _interopRequireDefault(require("@dragones-tech/eventing"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _iterableToArrayLimit(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _wrapNativeSuper(Class) {
  var _cache = typeof Map === "function" ? new Map() : undefined;

  _wrapNativeSuper = function _wrapNativeSuper(Class) {
    if (Class === null || !_isNativeFunction(Class)) return Class;

    if (typeof Class !== "function") {
      throw new TypeError("Super expression must either be null or a function");
    }

    if (typeof _cache !== "undefined") {
      if (_cache.has(Class)) return _cache.get(Class);

      _cache.set(Class, Wrapper);
    }

    function Wrapper() {
      return _construct(Class, arguments, _getPrototypeOf(this).constructor);
    }

    Wrapper.prototype = Object.create(Class.prototype, {
      constructor: {
        value: Wrapper,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    return _setPrototypeOf(Wrapper, Class);
  };

  return _wrapNativeSuper(Class);
}

function _construct(Parent, args, Class) {
  if (_isNativeReflectConstruct()) {
    _construct = Reflect.construct;
  } else {
    _construct = function _construct(Parent, args, Class) {
      var a = [null];
      a.push.apply(a, args);
      var Constructor = Function.bind.apply(Parent, a);
      var instance = new Constructor();
      if (Class) _setPrototypeOf(instance, Class.prototype);
      return instance;
    };
  }

  return _construct.apply(null, arguments);
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _isNativeFunction(fn) {
  return Function.toString.call(fn).indexOf("[native code]") !== -1;
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var AbstractView = /*#__PURE__*/function (_HTMLElement) {
  _inherits(AbstractView, _HTMLElement);

  var _super = _createSuper(AbstractView);

  function AbstractView() {
    var _this;

    _classCallCheck(this, AbstractView);

    _this = _super.call(this); // this.attachShadow({ mode: 'open' });

    _defineProperty(_assertThisInitialized(_this), "radio", _eventing["default"]);

    _defineProperty(_assertThisInitialized(_this), "ui", {});

    _defineProperty(_assertThisInitialized(_this), "uiElements", {});

    _defineProperty(_assertThisInitialized(_this), "uiEvents", {});

    _defineProperty(_assertThisInitialized(_this), "activeRegions", {});

    _defineProperty(_assertThisInitialized(_this), "regions", {});

    _defineProperty(_assertThisInitialized(_this), "radioEvents", {});

    return _this;
  }

  _createClass(AbstractView, [{
    key: "attributeChangedCallback",
    value: function attributeChangedCallback(attr, oldValue, newValue) {
      this.onChange(attr, oldValue, newValue);
    }
  }, {
    key: "connectedCallback",
    value: function connectedCallback() {
      this.render();
      this.bindRadio();
    }
  }, {
    key: "disconnectedCallback",
    value: function disconnectedCallback() {
      this.unBindEvents(this);
      this.destroyObservers();
      this.unBindRadio();
    }
  }, {
    key: "onChange",
    value: function onChange() {}
  }, {
    key: "bindRadio",
    value: function bindRadio() {
      for (var event in this.radioEvents) {
        this.radio.on(event, this.radioEvents[event]);
      }
    }
  }, {
    key: "unBindRadio",
    value: function unBindRadio() {
      for (var event in this.radioEvents) {
        var fn = this.radioEvents[event];
        this.radio.off(event, fn);
      }
    }
  }, {
    key: "destroyObservers",
    value: function destroyObservers() {
      if (this.model) {
        this.model.unsubscribe(this);
      }
    }
  }, {
    key: "destroyEvents",
    value: function destroyEvents(el) {
      var _this2 = this;

      var _loop = function _loop(key) {
        var _key$split = key.split(':'),
            _key$split2 = _slicedToArray(_key$split, 2),
            evt = _key$split2[0],
            selector = _key$split2[1];

        _this2.querySelectorAll(selector).forEach(function (element) {
          if (element === el) {
            element.removeEventListener(evt, _this2.uiEvents[key]);
          }
        });
      };

      for (var key in this.uiEvents) {
        _loop(key);
      }
    }
  }, {
    key: "unBindEvents",
    value: function unBindEvents() {
      var _this3 = this;

      var _loop2 = function _loop2(key) {
        var _key$split3 = key.split(':'),
            _key$split4 = _slicedToArray(_key$split3, 2),
            eventName = _key$split4[0],
            selector = _key$split4[1];

        _this3.querySelectorAll(selector).forEach(function (element) {
          element.removeEventListener(eventName, _this3.uiEvents[key]);
        });
      };

      for (var key in this.uiEvents) {
        _loop2(key);
      }
    }
  }, {
    key: "bindEvents",
    value: function bindEvents() {
      var _this4 = this;

      var _loop3 = function _loop3(key) {
        var _key$split5 = key.split(':'),
            _key$split6 = _slicedToArray(_key$split5, 2),
            eventName = _key$split6[0],
            selector = _key$split6[1];

        _this4.querySelectorAll(selector).forEach(function (element) {
          element.addEventListener(eventName, _this4.uiEvents[key]);
        });
      };

      for (var key in this.uiEvents) {
        _loop3(key);
      }
    }
  }, {
    key: "uiMap",
    value: function uiMap() {
      for (var key in this.uiElements) {
        var selector = this.uiElements[key];
        var element = this.querySelector(selector);

        if (element) {
          this.ui[key] = element;
        }
      }
    }
  }, {
    key: "mapRegions",
    value: function mapRegions() {
      for (var key in this.activeRegions) {
        var selector = this.activeRegions[key];
        var element = this.querySelector(selector);

        if (element) {
          this.regions[key] = element;
        }
      }
    }
  }, {
    key: "update",
    value: function update() {
      this.render();
    }
  }, {
    key: "onRender",
    value: function onRender() {}
  }, {
    key: "render",
    value: function render() {
      var tpl = document.createElement('template');
      tpl.innerHTML = this.template();
      this.innerHTML = '';
      this.appendChild(tpl.content.cloneNode(true));
      this.uiMap();
      this.bindEvents();
      this.mapRegions();
      this.onRender();
    }
  }]);

  return AbstractView;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));

var _default = AbstractView;
exports["default"] = _default;